<template>
  <div
    class="hm-jielong"
  >
    <div class="hm-jielong">
      <img
        class="img"
        :src="image"
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
  },
  data() {
    return {
      image:"https://imgcdn.hemiao100.com/hemiaoBase/jielong/temp3.jpg"
    };
  },
  watch: {},
  computed: {},
  mounted() {
  },
  methods: {
  }
};
</script>

<style>
.hm-jielong {
  font-size: 20px;
  text-align: center;
}
.img {
  width: 100%;
  font-size: 0;
}
</style>
